export default __webpack_public_path__ + "static/media/inactiveFolder.1b12f889.png";